export default __webpack_public_path__ + "static/media/homepage-background.efc1935e.png";